import React from 'react';
import { Typography } from '@material-ui/core';

export default function NotFound(props){
  return (
    <Typography variant="h4">Désolé, cette page n'éxiste pas</Typography>
  )
}